import { Link } from 'react-router-dom'
import ClientImage from '../../assets/images/TIKBOX_logo_Blue.jpg'
import { HOME } from '../../constants/Routes'

const Header = () => {
  return (
    <div className="tikbox-header tikbox-container">
      <div className="tikbox-header__container">
        <Link to={HOME}>
          <img src={ClientImage} alt="site-logo" />
        </Link>
        <Link to={HOME} className="tikbox-back__btn">
          App
        </Link>
      </div>
    </div>
  )
}

export default Header
